/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusArticleDto
 */
export interface NovitusArticleDto {
    /**
     * Nazwa towaru/usługi (1-60 znaków)
     * @type {string}
     * @memberof NovitusArticleDto
     */
    name: string;
    /**
     * Symbol stawki podatkowej może przyjąć wartości stawek od A do G
     * @type {string}
     * @memberof NovitusArticleDto
     */
    ptu: NovitusArticleDtoPtuEnum;
    /**
     * Cena sprzedawanego towaru
     * @type {string}
     * @memberof NovitusArticleDto
     */
    price: string;
    /**
     * Ilość sprzedawanego towaru z precyzją do 6 miejsc po przecinku
     * @type {string}
     * @memberof NovitusArticleDto
     */
    quantity: string;
    /**
     * Wartość kontrolna równa „quantity" x „price"
     * @type {string}
     * @memberof NovitusArticleDto
     */
    value: string;
    /**
     * Jednostka miary drukowana obok ilości sprzedawanego towaru
     * @type {string}
     * @memberof NovitusArticleDto
     */
    unit?: string;
    /**
     * Opis towaru drukowany pod nazwą właściwą
     * @type {string}
     * @memberof NovitusArticleDto
     */
    description?: string;
}


/**
 * @export
 */
export const NovitusArticleDtoPtuEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G'
} as const;
export type NovitusArticleDtoPtuEnum = typeof NovitusArticleDtoPtuEnum[keyof typeof NovitusArticleDtoPtuEnum];


/**
 * Check if a given object implements the NovitusArticleDto interface.
 */
export function instanceOfNovitusArticleDto(value: object): value is NovitusArticleDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ptu' in value) || value['ptu'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusArticleDtoFromJSON(json: any): NovitusArticleDto {
    return NovitusArticleDtoFromJSONTyped(json, false);
}

export function NovitusArticleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusArticleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ptu': json['ptu'],
        'price': json['price'],
        'quantity': json['quantity'],
        'value': json['value'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function NovitusArticleDtoToJSON(value?: NovitusArticleDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'ptu': value['ptu'],
        'price': value['price'],
        'quantity': value['quantity'],
        'value': value['value'],
        'unit': value['unit'],
        'description': value['description'],
    };
}

